import legacyGraphQLClient from "@/services/graphql/LegacyGraphQLClient";
import { AlertResponse } from "@/models";

const GET_NOTIFICATIONS = `query Notification($before: String, $date: DateTime){
   notifications(
    last: 100
    before: $before
    where: {
      and: [
        { createdDate: { gte: $date}}
        { isEnabled: { eq: true } }
        { isArchived: { eq: false } }
        { isAcknowledged: { eq: false } }
      ]
    }
  ) {
    nodes {
      id
      createdDate
      leaId
      message
      notificationTypeId
      notificationTypes {
        name
        notificationTypeDescription
      }
      product {
        name
      }
      productId
      title
      userId
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}`;

interface PageInfo {
  endCursor: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
}

export async function fetchAlerts() {
  legacyGraphQLClient.setEndpoint(
    process.env.ISTATION_ALERTS_API_URL || "/graphql"
  );
  try {
    // Backend only keeps 30 days of alerts
    // Adjust this if needed to fetch only newer alerts like 7 days or 14 days
    const DAYS_OLD = 30;
    const date = new Date(Date.now() - DAYS_OLD * 24 * 60 * 60 * 1000).toISOString();
    let allAlerts: AlertResponse[] = [];
    // Use the central GraphQL client
    let result = await legacyGraphQLClient.query<{
      notifications: { nodes: AlertResponse[]; pageInfo: PageInfo };
    }>(GET_NOTIFICATIONS, { before: null, date });

    if (result.errors) {
      console.error("GraphQL Errors:", result.errors);
      return [];
    }
    allAlerts = [...allAlerts, ...(result.data?.notifications.nodes || [])];
    // hopefully we will not have more than 100 alerts 💀
    while (result.data?.notifications.pageInfo?.hasPreviousPage) {
      const before = result.data?.notifications.pageInfo.startCursor;
      const nextResult = await legacyGraphQLClient.query<{
        notifications: { nodes: AlertResponse[]; pageInfo: PageInfo };
      }>(GET_NOTIFICATIONS, { before, date });
      if (nextResult.errors) {
        console.error("GraphQL Errors:", nextResult.errors);
        return [];
      }
      result.data = nextResult.data;
      allAlerts = [...allAlerts, ...(result.data?.notifications.nodes || [])];
    }

    return allAlerts;
  } catch (error) {
    console.error("Error fetching alerts:", error);
    return [];
  }
}
